import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    minWidth: 500,
  },
  content: {
    padding: theme.spacing(4, 4, 2, 4),
    textAlign: "center",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: 8,
    right: 8,
    color: "#e53935",
  },
  icon: {
    fontSize: 56,
    color: "#43a047",
  },
  title: {
    fontWeight: 700,
    marginTop: theme.spacing(1),
    fontSize: "1.2rem",
  },
  message: {
    marginTop: theme.spacing(1),
    color: "#444",
    fontSize: "0.95rem",
  },
  bullets: {
    listStyle: "disc",
    padding: 0,
    margin: theme.spacing(2, 0, 0, 10),
    textAlign: "left",
  },
  bullet: {
    margin: "4px 0",
    fontSize: "0.9rem",
    // color: "#ec6535",
  },
  actions: {
    justifyContent: "center",
    padding: theme.spacing(1, 4, 3, 4),
    gap: theme.spacing(2),
  },
  cancelBtn: {
    textTransform: "none",
    color: "#1976d2",
    border: "1px solid #1976d2",
    borderRadius: 9999,
    padding: "6px 22px",
    "&:hover": { backgroundColor: "#e3f2fd" },
  },
  confirmBtn: {
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    borderRadius: 9999,
    padding: "6px 22px",
    boxShadow: "none",
    "&:hover": { backgroundColor: "#9E4D27", boxShadow: "none" },
    "&.Mui-disabled": { backgroundColor: "#e0d2cb", color: "#fff" },
  },
}));

export default function ApproveForecastDialog({
  open,
  loading,
  info,
  onConfirm,
  onCancel,
}) {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      classes={{ paper: classes.paper }}
    >
      <DialogContent className={classes.content}>
        {!loading && (
          <IconButton
            size="small"
            className={classes.closeBtn}
            onClick={onCancel}
          >
            <CloseIcon />
          </IconButton>
        )}
        {/* <HelpOutlineIcon className={classes.icon} /> */}
        <CheckCircleIcon className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          Approve Forecast
        </Typography>
        <Typography className={classes.message}>
          Are you sure you want to approve this forecast?
        </Typography>
        {info && (info.cmoLabel || info.brand || info.receivedOn) && (
          <ul className={classes.bullets}>
            {info.cmoLabel && (
              <li className={classes.bullet}><Typography className={classes.message}>CMO name - {info.cmoLabel}</Typography></li>
            )}
            {info.brand && (
              <li className={classes.bullet}><Typography className={classes.message}>Brand name - {info.brand}</Typography></li>
            )}
            {info.receivedOn && (
              <li className={classes.bullet}>
                <Typography className={classes.message} >Forecast received on - {info.receivedOn}</Typography>
              </li>
            )}
          </ul>
        )}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          className={classes.cancelBtn}
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className={classes.confirmBtn}
          onClick={onConfirm}
          disabled={loading}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
